// extracted by mini-css-extract-plugin
export default {"git":"Info_git__4S2D9","name":"Info_name__drM2L","project":"Info_project__25H1p","info":"Info_info__8sC2u","para":"Info_para__uZDfs"};